export const CAN_USE_PAYMENT_DIALOG = 'ordering.can_change_payment_option'

export const CAN_USE_ORCAS_TMS_PORTAL = 'marketplace.can_use_orcas_tms_portal'
